// "Add back" on the faded Travel Pouch row. The add and the decline-marker reset
// live in ct-atc-flow.js (window.ctRestoreGift) with the rest of the pouch logic;
// that call also re-renders the drawer, which removes this row.
if (!customElements.get('cart-gift-restore')) {
  customElements.define(
    'cart-gift-restore',
    class CartGiftRestore extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.onClick.bind(this));
      }

      onClick() {
        if (typeof window.ctRestoreGift !== 'function') return;
        this.button.disabled = true;
        window.ctRestoreGift().finally(() => {
          this.button.disabled = false;
        });
      }
    }
  );
}
